import React, { useContext } from "react";
import "./menu.styles.scss";

import { GrClose } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { MouseContext } from "../../context/mouse-context";

const Menu = ({ currentPage }) => {
  const navigate = useNavigate();
  const { cursorChangeHandler } = useContext(MouseContext);

  return (
    <div className="menu">
      {currentPage ? (
        <div
          onClick={() => {
            navigate("/");
          }}
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="project-close"
        >
          <GrClose />
        </div>
      ) : (
        ""
      )}
      <div className="menu-item-wrapper">
        <div
          className={`menu-item`}
          onClick={() => navigate("/")}
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
        >
          Harriet Sprattland
        </div>
        <div
          className="menu-item"
          onClick={() => navigate("/about")}
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
        >
          About
        </div>
        <div
          className="menu-item work-button"
          onClick={() => navigate("/")}
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
        >
          Work
        </div>
        <div
          className="menu-item"
          onClick={() => navigate("/contact")}
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
        >
          Contact
        </div>
      </div>
    </div>
  );
};

export default Menu;
